let viewNext = true;

export function getViewNext() {
  return viewNext;
}

export function toggleViewNext() {
  viewNext = !viewNext;
}
